if (!customElements.get('tbc-companies-section')) {
  customElements.define('tbc-companies-section', class TbcCompaniesSection extends HTMLElement {
    connectedCallback() {
      this.splideElement = this.querySelector('[data-companies-splide]');
      if (!this.splideElement || typeof window.Splide === 'undefined') return;

      var speed = parseFloat(this.dataset.sliderSpeed);
      var widthDesktop = parseInt(this.dataset.slideWidthDesktop, 10);
      var widthTablet = parseInt(this.dataset.slideWidthTablet, 10);
      var widthMobile = parseInt(this.dataset.slideWidthMobile, 10);

      this.splide = new window.Splide(this.splideElement, {
        type: 'loop',
        drag: 'free',
        focus: 'center',
        perPage: 6,
        gap: '50px',
        fixedWidth: String(widthDesktop || 200) + 'px',
        autoScroll: {
          speed: Number.isFinite(speed) ? speed : 0.5,
        },
        arrows: false,
        pagination: false,
        pauseOnFocus: false,
        pauseOnHover: false,
        breakpoints: {
          989: {
            fixedWidth: String(widthTablet || widthDesktop || 220) + 'px',
          },
          749: {
            fixedWidth: String(widthMobile || widthTablet || widthDesktop || 250) + 'px',
          },
        },
      });

      var hasAutoScrollExtension =
        window.splide &&
        window.splide.Extensions &&
        window.splide.Extensions.AutoScroll;

      if (hasAutoScrollExtension) {
        this.splide.mount(window.splide.Extensions);
      } else {
        this.splide.mount();
      }
    }

    disconnectedCallback() {
      if (!this.splide) return;
      this.splide.destroy(true);
      this.splide = null;
    }
  });
}
